export var SettlementStatus;
(function (SettlementStatus) {
    SettlementStatus["Paid"] = "Paid";
    SettlementStatus["Pending"] = "Pending";
    SettlementStatus["Failed"] = "Failed";
    SettlementStatus["Canceled"] = "Canceled";
})(SettlementStatus || (SettlementStatus = {}));
//# sourceMappingURL=SettlementStatus.js.map